// extracted by mini-css-extract-plugin
module.exports = {"numbers":"page_numbers-module_numbers_5949f","next":"page_numbers-module_next_1db3f"};